<div *ngIf="loading" class="full">
  <loading i18n="@@front.login.loading">We are logging you in securely</loading>
</div>

<!-- Confrim Email -->
<div *ngIf="is(Status.EmailConfirm)" class="email-confirm">
  <image-text image="assets/images/icons/confirm-email.svg">
    <p class="text" data-testid="login-confirmEmailForm-message-txt" i18n="@@front.login.emailConfirm.description">An
      email has been sent to {{email.value}}, please click on the confirmation link.</p>
    <div>
      <button (click)="loginAgain()" data-testid="login-confirmEmailForm-backToLogin-btn" class="btn btn-outline mb-2"
        i18n="@@front.login.emailConfirm.backButton">Back to Login Form</button>
      &nbsp;
      <button (click)="submitLoginRequest()" data-testid="login-confirmEmailForm-reSend-btn"
        class="btn btn-outline mb-2" i18n="@@front.login.emailConfirm.actionButton">Resend confirmation email!</button>
    </div>
  </image-text>
</div>

<!-- Error -->
<error *ngIf="is(Status.Error)">
  <p class="text" i18n="@@front.login.error.description">Something went wrong please try again</p>
  <button class="btn btn-front btn-primary" (click)="loginAgain()" data-testid="login-otpForm-loginAgain-btn"
    i18n="@@front.login.error.actionButton">Login Again</button>
</error>

<!-- Login Form -->
<form *ngIf="is(Status.Email)" class="form signin" [formGroup]="loginForm">
  <div *ngIf="error" data-testid="login-form-errorMsg-txt" class="alert alert-warning">{{error}}</div>
  <div *ngIf="!error && ipVerificationResponse" class="alert"
    [class.alert-success]="ipVerificationResponse.key === ConfirmIpAddressResponseKey.OK"
    [class.alert-danger]="ipVerificationResponse.key !== ConfirmIpAddressResponseKey.OK">
    {{ipVerificationResponse.message}}
  </div>
  <form-field label="Email" class="front" i18n-label="@@front.login.form.email.label">
    <div class="d-flex align-items-center">
      <input type="email" data-testid="login-loginForm-email-txt" formControlName="email"
        placeholder="Your Email Address" class="flex-grow" required
        i18n-placeholder="@@front.login.form.email.placeholder">
    </div>
  </form-field>
  <form-field label="Password" class="front mb-2" i18n-label="@@front.login.form.password.label">
    <div class="d-flex align-items-center">
      <input showPassword type="password" formControlName="password" data-testid="login-loginForm-password-txt"
        placeholder="Your account Password" class="flex-grow" required minlength="6"
        i18n-placeholder="@@front.login.form.password.placeholder">
    </div>
  </form-field>

  <div class="text-end mb-4">
    <a routerLink="/forgot-password" data-testid="login-loginForm-forgetPassword-link"
      i18n="@@front.login.form.forgotPasswordLink">Forget password?</a>
  </div>

  <button type="submit" data-testid="login-loginForm-submit-btn"
    class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!loginForm.valid" (click)="onLoginSubmit()">
    <ng-container *ngIf="!loadingCaptcha" i18n="@@front.login.form.submitButton">Login</ng-container>
    <ng-container *ngIf="loadingCaptcha" i18n="@@front.login.form.loading">Loading...</ng-container>
  </button>

  <div *ngIf="!loading" class="bg-gray text-center">
    <ng-container data-testid="login-loginForm-signup-link" i18n="@@front.login.form.signupText">Don’t have an account?
      <a routerLink="/register" data-testid="login-otpForm-signUpLink-btn">Sign up here</a></ng-container>
  </div>
</form>

<!-- TOTP -->
<form *ngIf="is(Status.TOTP)" class="form totp" [formGroup]="totpForm">
  <div *ngIf="error" class="alert alert-warning">{{error}}</div>
  <p class="text-center" i18n="@@front.login.totp.description">Please enter the MFA code on your authenticator app</p>
  <otp-input [otpControl]="totpCode"></otp-input>

  <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100 mb-3"
    data-testid="login-otpForm-submit-btn" [disabled]="!totpForm.valid" (click)="onTotpSubmit()"
    i18n="@@front.login.totp.submitButton">Confirm Code</button>
  <div class="text-center">
    <button *ngIf="isSmsEnabled()" (click)="useSms()" class="btn btn-outline"
      data-testid="login-otpForm-senSMSInstead-btn">Send an SMS instead</button>
  </div>
</form>

<!-- SMS -->
<form *ngIf="is(Status.OTP)" class="form sms" [formGroup]="smsForm">
  <div *ngIf="error" class="alert alert-warning">{{error}}</div>
  <p class="text-center" i18n="@@front.login.otp.description">We sent a 6 digit verification code to your phone number
    {{phoneNumber}}</p>
  <otp-input [otpControl]="smsCode"></otp-input>

  <mat-checkbox class="mb-4" formControlName="rememberMe" i18n="@@front.login.otp.rememberMe">Skip SMS verification for
    1 month on this computer</mat-checkbox>

  <button type="submit" data-testid="login-otpForm-confirmCode-btn"
    class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!smsForm.valid" (click)="onOtpSubmit()"
    i18n="@@front.login.otp.submitButton">Confirm Code</button>
  <div class="text-center">
    <button (click)="useSms()" data-testid="login-otpForm-resendSms-btn" class="btn btn-outline"
      i18n="@@front.login.otp.resendSms">Resend SMS code</button>
    <span *ngIf="isCallEnabled()" class="d-inline-block px-2"></span>
    <button *ngIf="isCallEnabled()" (click)="useCall()" data-testid="login-otpForm-callMe-btn" class="btn btn-outline"
      i18n="@@front.login.otp.call">Call me instead</button>
  </div>
</form>